<template>
  <div class="manage">
    <div class="tabs">
      <div
        v-for="(item, index) in state"
        :key="index"
        class="btn"
        :class="{ selectBtn: index == nowIDx }"
        @click="cutState(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="$router.push('optionProduct')"
          >添加商品</el-button
        >
        <el-button size="small" @click="amendProducts(2)">删除商品</el-button>
      </div>
      <div class="flex">
        <el-input
          placeholder="请输入商品名称"
          v-model="keyword"
          clearable
          size="small"
        ></el-input>
        <el-button type="primary" size="small" @click="productLists"
          >搜索</el-button
        >
      </div>
    </div>
    <el-table
      ref="multipleSelection"
      :data="commodityList"
      height="100%"
      @selection-change="handleSelectionChange"
      v-loading="loading"
      :element-loading-text="loading_text"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" :index="getIndex" label="序号" sortable>
      </el-table-column>
      <el-table-column prop="room.name" label="店铺"> </el-table-column>
      <el-table-column prop="title" label="商品名称"> </el-table-column>

      <el-table-column label="商品 所需积分" width="180">
        <template slot-scope="scope">
          <div class="comPrice">
            <div class="img">
              <img :src="scope.row.pic" alt="" class="comImg" />
            </div>
            <div class="rgt">
              <span class="name">{{ scope.row.name }}</span>
              <span class="price">￥{{ scope.row.credit }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="库存" sortable></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180">
      </el-table-column>
      <el-table-column label="状态" width="180">
        <template slot-scope="scope">
          <div class="comPrice">
            <div class="rgt">
              <el-tag type="success" effect="dark" v-if="scope.row.status == 1">
                已上架
              </el-tag>
              <el-tag v-else type="danger" effect="dark"> 未上架 </el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="scope.row.edit == 0"
            @click="handleEdit(scope.row.id)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next, jumper"
      :total="total_num"
    >
    </el-pagination>
  </div>
</template>

<script>
import { deleteProduct, allianceProductStatus } from "@/api/integralMall";
import { allianceGoods } from "@/api/merchant";
import { mapGetters, mapActions } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  data() {
    return {
      idx: 1,
      total_num: 0,
      keyword: "",
      page: "1",
      type: "",
      nowIDx: 0,
      loading: true,
      loading_text: "正在加载中...",
      state: ["全部商品", "出售中", "已售罄", "仓库中"],
      tableData: [],
      labelData: [],
      labelDatas: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      value: "",
      input: "",
      multipleSelection: [],
      commodityList: [],
      // 添加商品弹窗
      addProduct: false,
    };
  },
  watch: {
    labelDatas: () => {
      console.log("我变化");
    },
  },
  mounted() {
    this.productLists();
  },
  methods: {
    ...mapActions(["sethttp"]),
    getIndex(index) {
      return 10 * (this.page - 1) + index + 1;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.productLists();
    },
    changestatus(row) {
      console.log("status", row);
      var data = {
        id: row.id,
        app_id: this.app_id,
        field: "alliance_goods",
        value: row.alliance_goods ? 1 : 0,
      };
      allianceProductStatus(data).then((res) => {
        console.log("res", res);
        this.productLists();
      });
    },
    // 切换
    cutState(index) {
      this.type = index;
      this.page = "1";
      this.productLists();
      this.nowIDx = index;
    },
    // 编辑商品
    handleEdit(index) {
      this.$router.push(`optionProduct?idE=${index}`);
    },
    // 删除商品 index 区分 jude 用于判断是否上架
    amendProducts(index, jude = 0) {
      if (this.multipleSelection == "") {
        this.$message.warning("请选择要操作的商品");
      } else {
        var multipleSelectionArr = this.multipleSelection;
        var idarr = [];
        for (var i = 0; i < script.multipleSelectionArr.length; i++) {
          idarr.push(multipleSelectionArr[i].id);
        }
        var goods_id = idarr.join(",");
        let data = {
          token: this.token,
          app_id: this.app_id,
          id: goods_id,
          marketable: jude,
        };
        switch (index) {
          case 2:
            delete data.marketable;
            this.delet(data);
            break;
        }
      }
    },
    // 推广
    handleDelete(index, row) {
      console.log(index, row);
    },
    // 选中的商品
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    // 商品来源去向
    goCreateGoods() {
      this.$router.push("optionProdduct");
    },
    // 状态列表
    productLists() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        limit: 10,
        type: this.type,
        keyword: this.keyword,
      };
      this.commodityList = [];
      allianceGoods(data).then((res) => {
        console.log("商品列表", res);
        if (res.code == 200) {
          var result = res.data;
          this.total_num = res.data.total_num;
          if (result.result.length > 0) {
            setTimeout(() => {
              this.loading = false;
              this.commodityList = result.result;
              this.commodityList.forEach((item) => {
                item.alliance_goods = item.alliance_goods == 1 ? true : false;
              });
              console.log("数据", this.commodityList);
            }, 400);
          } else {
            this.loading = false;
            this.loading_text = "暂无数据...";
          }
        } else {
          this.loading_text = "获取数据失败....";
          setTimeout(() => {
            this.loading = false;
            this.$message.warning(res.msg);
          }, 800);
        }
      });
    },
    // 删除
    delet(data) {
      deleteProduct(data).then((res) => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.reload();
      });
    },
  },
};
</script.multipleSelectionArr.length;>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.manage {
  width: 90%;
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  display: flex;
  flex-direction: column;
  .tabs {
    font-size: 14px;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .btn {
      width: 90px;
      height: 30px;
      margin-right: 10px;
      text-align: center;
      line-height: 30px;
      border-radius: 16px;
    }
    .selectBtn {
      background: #397dff;
      color: #fff;
      cursor: pointer;
    }
  }
  .filtrate {
    height: 36px;
    .top-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
  }
  .el-input {
    max-width: 200px;
  }
  .comPrice {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .img {
      width: 50px;
      height: 50px;
      overflow: hidden;
      line-height: 50px;
      .comImg {
        vertical-align: middle;
        width: 50px;
      }
    }
    .rgt {
      width: 60px;
      height: 50px;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      font-size: 14px;
      text-align: left;
      .name {
        color: rgba(3, 87, 255, 1);
        font-weight: 400;
        line-height: 21px;
        max-width: 100px;
        overflow: hidden;
        white-space: nowrap;

        text-overflow: ellipsis;
      }
      .price {
        color: rgba(255, 91, 3, 1);
        font-weight: 400;
        line-height: 21px;
      }
    }
  }
  .el-pagination {
    height: 60px;
    padding-top: 16px;
  }
}
</style>

<style lang="scss">
.manage {
  .el-button--small {
    padding: 9px 27px;
  }
  .cell {
    text-align: center;
  }
}
</style>
